export default __webpack_public_path__ + "static/media/Paper.bd6e1d19.svg";